import React, { Component } from 'react';
import AWS_S3 from 'aws-sdk/clients/s3';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { S3_BUCKET_NAME, IMAGE_SIZE_LIMIT_BYTES, VIDEO_SIZE_LIMIT_BYTES, MIN_TRANCODEING_VIDEO_SIZE_LIMIT_BYTES} from '../../constants';
import ButtonContent from '../ButtonContent';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import Button from '@material-ui/core/Button';
import NavigationTabs from '../nav/NavigationTabs'
import { MEDIA_LIBRARY_MESSAGE } from '../../static-content';
import ImageCropper from './Cropper';
import LoadMoreIcon from './../LoadMoreIcon';
import { AlertJsMessage, paginationLimit } from './../../helpers.js'
import { COLORS } from '../../styles/colors';
import InfiniteScroll from 'react-infinite-scroll-component';
import FilePreviewButton from './../FilePreviewButton';
import { faVideo, faImage } from '@fortawesome/free-solid-svg-icons'

const acceptTypes = {
  mixed: ['image/gif', 'image/jpeg', 'image/jpg', 'image/png', 'video/mp4', 'video/mov'],
  video: ['video/mp4', 'video/quicktime'],
  image: ['image/gif', 'image/jpeg', 'image/jpg', 'image/png'],
  audio: ['.mp3', '.m4a']
}

/**
 * Form
 */

const CATEGORY = 'LIBRARY';

export class List extends Component { // eslint-disable-line react/prefer-stateless-function
  state = {
    type: 'upload',
    dataLoaded: false,
    selectedFile: false,
    openModal: false,
    showCropper: false,
    uploadInput: {},
    isOpenFilePreview: false,
    previewFile: {}
  }

  componentDidMount() {
    if (!this.state.dataLoaded) {
      this.props.fetchAll({
        userId: this.props.userData.id,
        limit: paginationLimit.TEN,
        skip: 0
      }).then(() => {
        const { selectedFileId, files } = this.props;
        if (selectedFileId) {
          this.setState({
            ...this.state,
            dataLoaded: true,
            type: 'library',
            selectedFile: files[selectedFileId]
          })
        }
        this.setState({
          ...this.state,
          dataLoaded: true
        })
      });
    }
  }

  componentWillUnmount() {
    this.props.resetFiles();
  }

  handleFileChange({ target }) {
    const file = target.files[0];
    if (file) {
      if (acceptTypes.image.includes(file.type)) {
        if (file.size > IMAGE_SIZE_LIMIT_BYTES) {
          AlertJsMessage(`Image is too large. The image you are trying to upload has a size of ${file.size}. The limit for an image upload is ${IMAGE_SIZE_LIMIT_BYTES}. Please upload another image.`);
          this.setState({
            previewImageSrc: '',
            previewVideoSrc: '',
            fileLoaded: false
          })
        } else {
          this.setState({
            uploadInput: target,
            previewImageSrc: window.URL.createObjectURL(file),
            previewVideoSrc: '',
            fileLoaded: true,
            openModal: false,
            showCropper: true
          })
        }
      }
      if (file.type === 'video/mp4' || file.type === 'video/quicktime' || file.type === 'video/mov') {
        if (file.size > VIDEO_SIZE_LIMIT_BYTES) {
          AlertJsMessage(`Video is too large. The video you are trying to upload has a size of ${file.size}. The limit for a video upload is ${VIDEO_SIZE_LIMIT_BYTES}. Please upload another video.`);
          this.setState({
            previewImageSrc: '',
            previewVideoSrc: '',
            fileLoaded: false
          })
          return;
        } else {
          this.setState({
            uploadInput: target,
            previewVideoSrc: window.URL.createObjectURL(file),
            previewImageSrc: '',
            fileLoaded: true,
            openModal: false
          }, () => this.submitNewFile())
        }

      }
    } else {
      AlertJsMessage('No file selected.');
    }
  }

  getCroppedImage = (croppedImage, isCancelled) => {
    if (isCancelled) {
      this.setState({
        type: 'upload',
        previewVideoSrc: '',
        showCropper: false,
        previewImageSrc: false,
        fileLoaded: false,
        openModal: false
      })
    } else {
      this.setState({
        previewImageSrc: croppedImage,
        type: 'upload',
        previewVideoSrc: '',
        fileLoaded: true,
        openModal: false,
        showCropper: false
      }, () => this.submitNewFile());
    }
  }

  submitNewFile() {
    const { showLoader, hideLoader, userData, showAlert, fetchAll } = this.props;
    const { uploadInput, previewImageSrc } = this.state;
    this.setState({ isUploading: true });
    showLoader();
    const s3 = new AWS_S3({
      apiVersion: '2006-03-01',
      params: { Bucket: S3_BUCKET_NAME }
    });
    const { addFile } = this.props;
    let file = uploadInput.files && uploadInput.files[0];
    if (!file) return;
    const fileType = file.name.split('.').pop();
    let s3UploadObj = {
      Key: `${CATEGORY}-${Date.now()}.${fileType}`,
      Body: file,
      ACL: 'public-read'
    };
    if (acceptTypes.image.includes(file.type)) {
      const base64Data = new Buffer.from(this.state.previewImageSrc.replace(/^data:image\/\w+;base64,/, ""), 'base64');
      const type = previewImageSrc.split(';')[0].split('/')[1];
      s3UploadObj = {
        ...s3UploadObj,
        Body: base64Data,
        ContentEncoding: 'base64',
        ContentType: `image/${type}`
      };
    }
    return new Promise((resolve, rej) => {
      if (file) {
        let isTranscoding = false;
        if (file.size > MIN_TRANCODEING_VIDEO_SIZE_LIMIT_BYTES || file.type === 'video/quicktime' || file.type === 'video/mov') {
          isTranscoding = true;
        }
        s3.upload(s3UploadObj, (err, ec2Data) => {
          if (err) {
            AlertJsMessage('There was an error uploading your photo: ', err.message);
            hideLoader();
            rej('');
          }
        
          addFile({
            userId: userData._id,
            url:  `https://${process.env.REACT_APP_ASSET_URL}/${ec2Data.Key}`,
            category: CATEGORY,
            fileType: fileType,
            name: file.name,
            isLibrary: true,
            isTranscoding
          }).then((newFile) => {
            hideLoader();
            showAlert(`${isTranscoding ? 'File is processing. Once it processed then we will inform you.' :  'File uploaded successfully.'}`);
            fetchAll({
              userId: this.props.userData.id,
              limit: paginationLimit.TEN,
              skip: 0
            });
            resolve(newFile);
          });
        });
      } else {
        hideLoader();
        showAlert('Failed to load file. Please try again.', true);
        rej('No File');
      }
    });
  }

  openFilePreview(file) {
    this.setState({
      isOpenFilePreview: true,
      previewFile: file
    })
  }

  

  render() {
    const { dataLoaded, previewImageSrc, showCropper } = this.state;
    const { user } = this.props;
    const fileType = "mixed";
    const files =  this.props.files.data
    .filter((file) => {
      return file.userId.includes(user._id)
    });
    return (
      <div>
        <NavigationTabs
          title="Library"
          subtitle="Cover Photo/Video"
          description={MEDIA_LIBRARY_MESSAGE}
          set="library"
          activeRoute="/library/media" />

        <div style={{ padding: 10 }}>
          <Button
            color='secondary'
            variant="contained"
            component="label"
            onClick={() => this.setState({ ...this.state, openModal: true })}
          >
            <input
              type="file"
              onChange={(e) => this.handleFileChange(e)}
              accept={acceptTypes[fileType].toString()}
              style={{ display: "none" }}
            />
            <ButtonContent
              text="Upload New Photo or Video"
              icon="upload"
            />
          </Button>
        </div>
        { this.state.isOpenFilePreview && 
          <FilePreviewButton 
            isOpen= {this.state.isOpenFilePreview} 
            item = {this.state.previewFile } 
            handleClose = {
              () => {
                this.setState({
                  isOpenFilePreview: false
                })
              }
            }
          />
        } 
        {dataLoaded &&
          <div id="scrollableFile" style={{
            overflow: 'auto',
            height: 400
          }}>
            <InfiniteScroll
                dataLength={files.length} //This is important field to render the next data
                next={() =>  {
                  this.props.fetchAll({
                    userId: this.props.userData.id,
                    limit: paginationLimit.TEN,
                    skip: files.length
                  })
                }}
                hasMore={this.props.files.isLoadMore}
                scrollableTarget="scrollableFile"
                loader={<LoadMoreIcon/>}
            >
                <GridList cellHeight={150}>
                  {files.map(file => {
                    return (
                      <GridListTile
                        key={file._id}>
                        <span style={{'position': 'relative'}}>
                          
                        <FontAwesomeIcon icon="eye" title={'Preview'}
                          onClick={() => this.openFilePreview(file)}
                          style={{ 
                              marginRight: 5, 
                              color: COLORS.orange, 
                              position: 'absolute', 
                              bottom: 0, 
                              right:20,
                              cursor: 'pointer' 
                            }}
                          />
                          <FontAwesomeIcon icon={
                            acceptTypes[fileType].includes('image/' + file.fileType) ? faImage : faVideo
                          } title={file.name}
                            style={{ 
                              marginRight: 5, 
                              color: COLORS.orange, 
                              position: 'absolute', 
                              bottom: 0, 
                              right:0, 
                              cursor: 'pointer'
                            }}
                          />
                        {
                          acceptTypes[fileType].includes('image/' + file.fileType) ? (
                            <img src={file.url} alt={file.name} />
                          ) : (
                            <img src={file.screenShotUrl} alt={file.name} />
                            )
                        }
                           </span>
                     

                      </GridListTile>
                    )
                  })}
                </GridList>
            </InfiniteScroll>
          </div>
        }
        {showCropper && <ImageCropper showCropper={showCropper} fileUrl={previewImageSrc} getCroppedImage={this.getCroppedImage} />}
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/files/List.js